import { call, ForkEffect, put, takeEvery } from 'redux-saga/effects';
import { makeRequest } from 'utilities/fetch/api-gateway.js';
import {
  REDUX_BRIGHTCOVE_GET_STATUS_ASYNC,
  REDUX_BRIGHTCOVE_GET_STATUS_ERROR,
  REDUX_BRIGHTCOVE_GET_STATUS_SUCCESS,
} from './reducer.js';
import { IBrightcoveData } from './types.js';

/**
 * In development we need this request to go to the mock server
 * We use Build-Env here so that we can control to use mock in production like environment
 *
 * MetService provides a JSON file for us to check on the videos being available.
 * The playlist that come in the `video-summary` payload have a `key` attribute
 * which will be used to check if a certain video is available or not:
 * JSON[key] = true | false;
 */
function* getBrightcoveStatus() {
  try {
    const path = '/dynamic/feeds/brightcove_playlist_info.json?v=1';
    const status: Record<string, IBrightcoveData> = yield call(makeRequest, {
      path,
      apiPrefix: false,
    });
    yield put(REDUX_BRIGHTCOVE_GET_STATUS_SUCCESS({ status }));
  } catch {
    yield put(REDUX_BRIGHTCOVE_GET_STATUS_ERROR());
  }
}

export default function* brightcoveSaga(): IterableIterator<ForkEffect<never>> {
  const type = REDUX_BRIGHTCOVE_GET_STATUS_ASYNC().type;
  yield takeEvery(type, getBrightcoveStatus);
}
